<template>
  <div class="destination-business-tree-grid grid-view">
    <div class="main-content">
      <search-item
        config-module="231501"
        :reset="true"
        :custom-search-items="customSearchItems"
        :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
        @preProcessSearchItem="filterFinanceSearchItems"
      >
        <div slot="operations">
          <!--查看-->
          <el-button :disabled="selectedRowCount === 0" type="success" @click="toLook()">{{ $t('common.btn.look') }}</el-button>
          <!--编辑-->
          <el-button :disabled="!canEdit || selectedRowCount === 0" type="primary" @click="toEdit()">{{ $t('common.btn.edit') }}</el-button>
          <!--审核通过-->
          <el-button v-if="canAuditPass" type="primary" @click="toAuditPass()">{{ $t('CargoMsg.Cargo_EndCommerceAuditPassBtn') }}</el-button>
          <!--退回-->
          <el-button v-if="menuType === 'endCommerce'" type="warning" @click="toOpenReturnDialog()">退回</el-button>
        </div>
      </search-item>
      <div class="section grid-wrapper" style="min-height:350px">
        <cargo-ag-grid
          config-module="23151200"
          :grid-options="gridOptions"
          :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
          :column-defs="columnDefs"
          :row-data="rowData"
          :grid-params.sync="gridParams"
          :enable-col-resize="true"
          :enable-sorting="true"
          :check-main-record="false"
          :deselect-main-record="false"
          class="ag-theme-balham"
          style="width: 100%;"
          @gridReady="onGridReady"
        />
      </div>
      <div class="destination-amount-sum">
        <span>
          {{ $t('CargoMsg.Cargo_TicketCount') + ' ' + ticketCount }}
        </span>
        <label style="margin-right: 20px;" />
        <span>
          {{ $t('CargoMsg.Cargo_CartonQuantity') + '  ：  ' + cartonQuantity }}
        </span>
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="23151200"
          :total="total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toQuery()"
        />
      </div>
    </div>
    <!--退回弹窗-->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="returnDialog.visible"
      title="温馨提示"
      width="480px"
      :close-on-click-modal="false"
      :before-close="() => { returnDialog.visible = false }"
    >
      <div style="padding: 0 20px;">
        <div style="font-size: 16px; margin-bottom: 20px;">确定退回后重新提交吗？</div>
        <el-form label-width="110px" label-position="right">
          <el-form-item label="选择退回的模块">
            <el-select v-model="returnDialog.module" disabled style="width: 100%;">
              <el-option label="海运订舱" value="SEA_BOOKING" />
            </el-select>
          </el-form-item>
          <el-form-item label="退回原因">
            <el-input
              v-model="returnDialog.reason"
              type="textarea"
              :rows="4"
              placeholder="请输入退回原因"
              maxlength="500"
              show-word-limit
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="returnDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="toConfirmReturn">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as LayersUtil from '@/class/cargo/model/utils/LayersUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { findDestinationBusinessJobs, finalStepAuditPass, finalStepReturn } from '@/api/booking/destinationBusiness'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import DateUtils from '@/utils/dateUtils'
import { stringToBool } from '@/utils/commonUtil'
import { buildDestinationServiceFieldConfig } from '@/views/cargo/v0/SeaExport/components/booking/destinationServiceQuery'

export default {
  name: 'DestinationBusinessTreeGrid',
  components: { searchItem },
  props: {
    menuType: {
      type: String,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    canAuditPass: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isAdvancedQuery: false,
      returnDialog: {
        visible: false,
        module: 'SEA_BOOKING',
        reason: '',
        jobKeys: []
      },
      filter: {
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      selectedRowCount: 0,
      selectedJob: null,
      gridParams: {},
      loading: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        onRowClicked: this.onRowClicked,
        onRowSelected: (event) => { this.onRowSelected(event) },
        onRowDoubleClicked: event => { this.toLook(event.data) },
        getRowStyle: (params) => {
          const row = params.data
          const colorType = Number(this.$store.state.settings.colorType) === 1
          if (colorType) {
            return JobUtils.financeColor(row)
          } else if (Object.prototype.hasOwnProperty.call(row, 'blocked') &&
            Object.prototype.hasOwnProperty.call(row, 'specialApproval') &&
            JobUtils.isBlockJob(row)) {
            return { 'background': LayersUtil.STATE_BLOCKED.colorValue }
          } else {
            const jobState = String(row.jobState) || ''
            for (const stateColor of LayersUtil.COLOR_STATES) {
              if (jobState === stateColor.colorKey) {
                return { 'background': stateColor.colorValue }
              }
            }
          }
          return {}
        },
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '', width: 45, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        }, {
          headerName: this.$t('SeaExport.BusinessNo'),
          field: 'jobNo',
          colId: 'jobNo',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Carrier'),
          field: 'carrierId',
          colId: 'carrierId',
          cellRenderer: (params) => {
            return ColumnUtils.carrierLabelFunc(params.data, params.data.carrierId)
          },
          width: 200,
          hide: true,
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.carrierLabelFunc(params.data, params.data.carrierId)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_TruckingCompany'),
          colId: 'carryingCmp',
          field: 'carryingCmp',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_11') : ''
          },
          hide: true,
          width: 200,
          filterParams: {},
          filterValueGetter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.data.carryingCmp, 'auto_11')
          }
        }, {
          headerName: this.$t('SeaExport.Vessel'),
          field: 'vessel',
          colId: 'vessel',
          width: 150,
          hide: true
        }, {
          headerName: this.$t('SeaExport.Voyage'),
          field: 'voyageFlight',
          colId: 'voyageFlight',
          width: 150,
          hide: true
        }, {
          headerName: 'SOP',
          field: 'sopState',
          colId: 'sopState',
          width: 150,
          tooltipValueGetter: (params) => params.value
        }, {
          headerName: this.$t('CargoMsg.Cargo_CustomerChineseName'),
          colId: 'customerId',
          field: 'customerId',
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0') : ''
          },
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_CustomerEnglishName'),
          colId: 'englishName',
          field: 'englishName',
          width: 200,
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_BusinessDate'),
          field: 'businessDate',
          colId: 'businessDate',
          cellRenderer: (params) => {
            return DateUtils.formatStandardDate(params.value)
          },
          width: 150,
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_BusinessType'),
          field: 'lob',
          colId: 'lob',
          valueFormatter: (params) => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_PortOfLoading'),
          colId: 'loadingPortCode',
          field: 'loadingPortCode',
          valueFormatter: (params) => {
            return ColumnUtils.getPortLabel('code', params.value, params.data, 'auto_7')
          },
          width: 150,
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.getPortLabel('code', params.data.loadingPortCode, params.data, 'auto_7')
          }
        }, {
          headerName: this.$t('SeaExport.PlaceOfDelivery'),
          colId: 'destinationPortCode',
          field: 'destinationPortCode',
          valueFormatter: (params) => {
            return ColumnUtils.getPortLabel('code', params.value, params.data, 'auto_7')
          },
          width: 150,
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.getPortLabel('code', params.data.destinationPortCode, params.data, 'auto_7')
          }
        }, {
          headerName: this.$t('SeaExport.DateOfDeparture'),
          field: 'etd',
          colId: 'etd',
          cellRenderer: (params) => {
            return DateUtils.formatStandardDate(params.value)
          },
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_ArrivalDate'),
          field: 'eta',
          colId: 'eta',
          cellRenderer: (params) => {
            return DateUtils.formatStandardDate(params.value)
          },
          width: 150,
          hide: true
        }, {
          headerName: this.$t('SeaExport.FinalDestination'),
          field: 'destinationPlace',
          colId: 'destinationPlace',
          width: 150,
          hide: true
        }, {
          headerName: this.$t('SeaExport.Operation'),
          field: 'op',
          colId: 'op',
          valueFormatter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomerService'),
          field: 'csr',
          colId: 'csr',
          valueFormatter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op')
          },
          width: 150,
          hide: true
        }, {
          headerName: this.$t('SeaExport.Sales'),
          field: 'sales',
          colId: 'sales',
          valueFormatter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.SalesDepartment'),
          field: 'salesDepartment',
          colId: 'salesDepartment',
          width: 200,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.OverseaCustomerService'),
          field: 'overseaOp',
          colId: 'overseaOp',
          width: 180,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('queryJob.destinationAgent'),
          field: 'destinationAgent',
          colId: 'destinationAgent',
          enableRowGroup: true,
          hide: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_2') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.NominatedAgent'),
          field: 'designationAgent',
          colId: 'designationAgent',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_3') : ''
          },
          width: 200,
          hide: true
        }, {
          headerName: 'MB/L NO',
          field: 'mbl',
          colId: 'mbl',
          valueFormatter: (params) => {
            return ColumnUtils.mblLabelFunc(params.value, params.data)
          },
          width: 150,
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.mblLabelFunc(params.data.mbl, params.data)
          }
        }, {
          headerName: 'HB/L NO',
          field: 'hblNo',
          colId: 'hblNo',
          width: 150
        }, {
          headerName: this.$t('SeaExport.ItemNo'),
          field: 'poNo',
          colId: 'poNo',
          width: 150,
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_PrePortBusinessLeader'),
          field: 'prePortPlanner',
          colId: 'prePortPlanner',
          width: 100,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value || 0), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.AirlinePerson2'),
          field: 'planner',
          colId: 'planner',
          width: 100,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value || 0), 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_LastMileBusinessLeader'),
          field: 'lastMilePlanner',
          colId: 'lastMilePlanner',
          width: 100,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value || 0), 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_preportAuditStatus'),
          field: 'prePortApproveStatus',
          colId: 'prePortApproveStatus',
          enableRowGroup: true,
          hide: true,
          valueGetter: (params) => {
            return ColumnUtils.priceJobStateLabelFunc(params.data.prePortPlanner, Number(params.data.prePortApproveStatus))
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.priceJobStateLabelFunc(params.data.prePortPlanner, Number(params.data.prePortApproveStatus))
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_TrunkLineAuditStatus'),
          field: 'trunkLineApproveStatus',
          colId: 'trunkLineApproveStatus',
          enableRowGroup: true,
          hide: true,
          valueGetter: (params) => {
            return ColumnUtils.priceJobStateLabelFunc(params.data.planner, Number(params.data.trunkLineApproveStatus))
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.priceJobStateLabelFunc(params.data.planner, Number(params.data.trunkLineApproveStatus))
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.Status'),
          field: 'jobState',
          colId: 'jobState',
          cellRenderer: (params) => {
            return ColumnUtils.getJobStateForBlock(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.getJobStateForBlock(params.data)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ShutOut'),
          colId: 'shutOut',
          enableRowGroup: true,
          hide: true,
          valueGetter: (params) => {
            if (!params.data) return undefined
            const d = params.data
            return d.isShutOut !== undefined && d.isShutOut !== null ? d.isShutOut : d.shutOut
          },
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          filterParams: {},
          filterValueGetter: (params) => {
            if (!params.data) return ''
            const d = params.data
            const v = d.isShutOut !== undefined && d.isShutOut !== null ? d.isShutOut : d.shutOut
            return ColumnUtils.booleanLabelFunction(stringToBool(v))
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.CommissionedNumberOfPackages'),
          field: 'quantityContract',
          colId: 'quantityContract',
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          },
          width: 150,
          hide: true
        }, {
          headerName: this.$t('SeaExport.CommissionedGrossWeight'),
          field: 'weightContract',
          colId: 'weightContract',
          cellRenderer: (params) => {
            if (!params.value) params.value = ''
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 150,
          hide: true
        }, {
          headerName: this.$t('SeaExport.CommissionedVolume'),
          field: 'cubageContract',
          colId: 'cubageContract',
          cellRenderer: (params) => {
            if (!params.value) params.value = ''
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 150,
          hide: true
        }, {
          headerName: this.$t('SeaExport.ActualQuantity'),
          field: 'quantityActual',
          colId: 'quantityActual',
          cellRenderer: (params) => {
            if (!params.value) params.value = ''
            return ColumnUtils.numberColumnLabelFunc(params.value)
          },
          width: 150,
          hide: true
        }, {
          headerName: this.$t('SeaExport.ActualWeight'),
          field: 'weightActual',
          colId: 'weightActual',
          cellRenderer: (params) => {
            if (!params.value) params.value = ''
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 150,
          hide: true
        }, {
          headerName: this.$t('SeaExport.ActualVolume'),
          field: 'cubageActual',
          colId: 'cubageActual',
          cellRenderer: (params) => {
            if (!params.value) params.value = ''
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 150,
          hide: true
        }, {
          headerName: this.$t('SeaExport.ContainerDescription'),
          field: 'containerDesc',
          colId: 'containerDesc',
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.containerDescLabelFunc(params.value)
          },
          width: 150,
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.containerDescLabelFunc(params.data.containerDesc)
          }
        }, {
          headerName: this.$t('SeaExport.TradeTerms2'),
          field: 'incoTerm',
          hide: true,
          width: 180,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.LocalService'),
          field: 'loadingTerm',
          colId: 'loadingTerm',
          cellRenderer: (params) => {
            return ColumnUtils.loadingTermNewLabelFunction(params.data, params.value)
          },
          hide: true,
          width: 150,
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.loadingTermNewLabelFunction(params.data, params.data.loadingTerm)
          }
        }, {
          headerName: this.$t('SeaExport.DateOfCreation'),
          field: 'dateCreated',
          colId: 'dateCreated',
          width: 120,
          hide: true
        }, {
          headerName: this.$t('SeaExport.BusinessReferenceNo'),
          field: 'customerRefNo',
          colId: 'customerRefNo',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.DeliveryDate'),
          field: 'destPortDeliveryTime',
          colId: 'destPortDeliveryTime',
          width: 150,
          hide: true,
          cellRenderer: (params) => {
            return DateUtils.formatStandardDate(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.UserDefinedField1'),
          field: 'userDefinedField1',
          colId: 'userDefinedField1',
          width: 180,
          hide: true
        }, {
          headerName: this.$t('SeaExport.UserDefinedField2'),
          field: 'userDefinedField2',
          colId: 'userDefinedField2',
          width: 180,
          hide: true
        }, {
          headerName: this.$t('SeaExport.UserDefinedField3'),
          field: 'userDefinedField3',
          colId: 'userDefinedField3',
          width: 180,
          hide: true
        }, {
          headerName: this.$t('SeaExport.UserDefinedField4'),
          field: 'userDefinedField4',
          colId: 'userDefinedField4',
          width: 180,
          hide: true
        }, {
          headerName: this.$t('SeaExport.OperationDate'),
          field: 'customsDate',
          colId: 'customsDate',
          width: 180,
          hide: true,
          valueFormatter: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.ActualDateOfDeparture2'),
          field: 'atd',
          colId: 'atd',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 150,
          hide: true
        }, {
          headerName: this.$t('SeaExport.ActualDateOfArrival2'),
          field: 'ata',
          colId: 'ata',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 150,
          hide: true
        }, {
          headerName: this.$t('SeaExport.CargoType'),
          field: 'cargoType',
          colId: 'cargoType',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.MasterBLFreightTerm'),
          field: 'paymentTermMBL',
          colId: 'paymentTermMBL',
          hide: true,
          width: 150,
          valueGetter: (params) => {
            if (params.data) {
              return ColumnUtils.paymentTermLabelFunc(params.data.paymentTermMBL)
            }
            return ''
          }
        }, {
          headerName: this.$t('SeaExport.HBLFreightClause'),
          field: 'paymentTermHBL',
          colId: 'paymentTermHBL',
          hide: true,
          width: 150,
          valueGetter: (params) => {
            if (params.data) {
              return ColumnUtils.paymentTermLabelFunc(params.data.paymentTermHBL)
            }
            return ''
          }
        }, {
          headerName: this.$t('SeaExport.ActualLiftingDate'),
          field: 'actualPickUpTime',
          colId: 'actualPickUpTime',
          hide: true,
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.ActualReturnTime'),
          field: 'destPortReturnTime',
          colId: 'destPortReturnTime',
          hide: true,
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.SolicitationType'),
          field: 'cargoSource',
          colId: 'cargoSource',
          cellRenderer: (params) => {
            return ColumnUtils.cargoSourceLabelFunction(params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ApproachDate'),
          colId: 'approachDate',
          field: 'approachDate',
          cellRenderer: (params) => {
            return DateUtils.formatStandardDateTime(params.value)
          },
          width: 120,
          hide: true
        }, {
          headerName: this.$t('SeaExport.Marks'),
          field: 'mark',
          colId: 'mark',
          initialWidth: 100,
          hide: true
        }, {
          headerName: this.$t('Message.Customer_Service'),
          colId: 'csrDepartment',
          field: 'csrDepartment',
          width: 180,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('Message.Documentation_Department'),
          colId: 'dcDepartment',
          field: 'dcDepartment',
          width: 180,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.CustomerLevel'),
          field: 'customerTypeId',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CustomerType, 'typeId', params.value, 'chineseName')
          },
          width: 150,
          hide: true
        }, {
          headerName: this.$t('SeaExport.Consignee'),
          colId: 'consigneeLine1',
          field: 'hblConsigneeLine1',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Shipper'),
          colId: 'shipperLine1',
          field: 'hblShipperLine1',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_BookingWindow'),
          field: 'bookingAgent',
          colId: 'bookingAgent',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_1') : ''
          },
          width: 200,
          hide: true
        }, {
          headerName: '海外跟单',
          field: 'userDefinedRoleId4',
          colId: 'userDefinedRoleId4',
          width: 140,
          enableRowGroup: true,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value || 0), 'chineseName')
          }
        }
      ],
      rowData: [],
      gridApi: null,
      ticketCount: 0,
      cartonQuantity: '',
      initTicketCount: 0,
      initCartonQuantity: '',
      customSearchItems: []
    }
  },
  created() {
    // 根据菜单类型动态调整列和查询条件
    if (this.menuType === 'endCommerce') {
      // 尾程商务负责人：在 endCommerce 场景下显示此列（默认 hide: true）
      const leaderCol = this.columnDefs.find(col => col.colId === 'lastMilePlanner')
      if (leaderCol) {
        leaderCol.hide = false
        leaderCol.width = 150
      }
      // 是否尾程审核
      this.columnDefs.push({
        headerName: this.$t('CargoMsg.Cargo_EndCommerceFinalStepAudit'),
        field: 'finalStepAudit',
        colId: 'finalStepAudit',
        hide: true,
        valueGetter: (params) => {
          if (!params.data) return ''
          return this.getFinalStepAuditText(params.data)
        },
        filterParams: {},
        filterValueGetter: (params) => {
          if (!params.data) return ''
          return this.getFinalStepAuditText(params.data)
        },
        width: 150
      })
      // 尾程商务 - 检索条件
      this.customSearchItems = this.buildEndCommerceSearchItems()
    } else if (this.menuType === 'overseaTracking') {
      // 海外跟单 - 检索条件
      this.customSearchItems = this.buildOverseaTrackingSearchItems()
    }
  },
  activated() {
    // 从详情页退回操作返回时，刷新列表
    if (this.$store.state.destinationBusiness.needRefreshList) {
      this.$store.dispatch('destinationBusiness/setNeedRefreshList', false)
      this.toQuery()
    }
  },
  methods: {
    // 构建尾程商务查询条件
    buildEndCommerceSearchItems() {
      const searchItems = [
        // 1. REMOVE_ACTION: 清除旧字段名 job.FINAL_STEP_AUDIT_STATUS（已废弃，后端列不存在）
        {
          action: 1,
          itemType: 'select',
          fieldType: 'FIELD_DROP_DOWN_LIST',
          itemName: 'job.FINAL_STEP_AUDIT_STATUS'
        },
        // 2. UPDATE_ACTION: 使用正确字段名 job.FINAL_STEP_AUDIT，并默认显示
        {
          action: 2,
          itemType: 'select',
          multiple: 0,
          itemCondition: [{
            code: '=',
            chineseName: '等于',
            englishName: 'Equal',
            children: null,
            selected: false
          }],
          defaultConditionVal: '=',
          fieldType: 'FIELD_MULTI_DROP_DOWN_LIST',
          itemName: 'job.FINAL_STEP_AUDIT',
          itemLabel: 'CargoMsg.Cargo_EndCommerceFinalStepAudit',
          itemValue: '',
          defaultSelected: 1,
          selected: 0,
          dropdownDataRef: '',
          dataCacheKey: '',
          valueExpression: {
            valueType: 'static',
            valueContent: [
              { code: '1', chineseName: this.$t('CargoMsg.Cargo_EndCommerceAudited'), englishName: 'Audited' },
              { code: '0', chineseName: this.$t('CargoMsg.Cargo_EndCommerceNotAudited'), englishName: 'Not Audited' },
              { code: 'null', chineseName: this.$t('CargoMsg.Cargo_EndCommerceNoAuditRequired'), englishName: 'No Audit Required' }
            ]
          },
          lock: false,
          defaultValue: ''
        },
        // 海外跟单 - 检索条件
        this.buildOverseaTrackerSearchItem(),
        // 目的港服务（包含/等于 dual-path：虚拟字段 job.portOfDestinationServices 原样下发，后端 JobUtil 拦截拼 OR/AND）
        this.buildPortOfDestinationServiceItem()
      ]
      return searchItems
    },
    // 构建海外跟单查询条件
    buildOverseaTrackingSearchItems() {
      const searchItems = [
        this.buildOverseaTrackerSearchItem(),
        // 目的港服务（包含/等于 dual-path：虚拟字段 job.portOfDestinationServices 原样下发，后端 JobUtil 拦截拼 OR/AND）
        this.buildPortOfDestinationServiceItem()
      ]
      return searchItems
    },
    // 构建"海外跟单"查询条件项
    buildOverseaTrackerSearchItem() {
      const searchField = new AdvancedSearchField()
      // 使用 UPDATE_ACTION：如果默认配置中存在则更新，不存在则新增
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'user'
      searchField.fieldType = 'FIELD_USER'
      searchField.subType = {
        category: 'role',
        shape: 'userDefinedRole4'
      }
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.itemName = 'job.user_defined_role_id_4'
      searchField.itemLabel = '海外跟单'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.valueExpression = ''
      searchField.lock = false
      searchField.defaultValue = ''
      return searchField.formatObj2Json()
    },
    // 构建"目的港服务"查询条件项（REQ-0012：包含/等于 dual-path）
    // 范式参考 job.FINAL_STEP_AUDIT（自包含 UPDATE_ACTION 项）。originField 经 buildDestinationServiceFieldConfig
    // 覆写 itemCondition=[OPERATOR_IN,OPERATOR_EQUAL] / defaultConditionVal=OPERATOR_IN.code / multiple=1；
    // 虚拟字段 job.portOfDestinationServices 由 buildConditions 原样下发，后端 JobUtil 拦截拼 OR(包含)/AND(等于)。
    // 静态下拉值：1=目的港清关 2=目的港派车 3=美国清关（与后端 POD_SERVICE_CODE_TO_COLUMN 一致）。
    buildPortOfDestinationServiceItem() {
      const originField = {
        itemType: 'select',
        fieldType: 'FIELD_MULTI_DROP_DOWN_LIST',
        itemName: 'job.portOfDestinationServices',
        itemLabel: this.$t('SeaExport.PortOfDestinationServices'),
        itemValue: '',
        defaultSelected: 0,
        selected: 0,
        dropdownDataRef: '',
        dataCacheKey: '',
        valueExpression: {
          valueType: 'static',
          valueContent: [
            { code: '1', chineseName: this.$t('SeaExport.PortOfDestinationCustomsClearance'), englishName: 'Destination Port Customs Clearance' },
            { code: '2', chineseName: this.$t('SeaExport.DispatchVehiclesAtDestination'), englishName: 'Dispatch Vehicles at Destination' },
            { code: '3', chineseName: this.$t('queryJob.UsCustomsClearance'), englishName: 'US Customs Clearance' }
          ]
        },
        lock: false,
        defaultValue: ''
      }
      const field = buildDestinationServiceFieldConfig(originField)
      field.action = AdvancedSearchField.UPDATE_ACTION
      return field
    },
    // 查询[简单查询/高级查询]
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 高级查询
    toAdvancedQuery(data) {
      this.loading = getLoading()
      if (typeof data !== 'undefined') {
        this.filter.conditions = data
        this.filter.pageNum = 1
      }
      if (!this.filter.conditions) this.filter.conditions = []
      const requestBody = {
        menuType: this.menuType,
        conditions: this.buildConditions(this.filter.conditions),
        pageNum: this.filter.pageNum,
        pageSize: this.filter.pageSize,
        branchId: this.$store.getters.currentOfficeId
      }
      findDestinationBusinessJobs(requestBody).then(res => this.handleQueryData(res.data)).finally(() => {
        this.loading.close()
      })
    },
    // 简单查询
    toSimpleQuery(keyword) {
      this.loading = getLoading()
      if (typeof keyword !== 'undefined') {
        this.filter.jobNo = keyword.trim()
        this.filter.pageNum = 1
      }
      if (!this.filter.conditions) this.filter.conditions = []
      const simpleConditions = []
      if (this.filter.jobNo) {
        simpleConditions.push(new AdvancedSearchOption(null, 'job.JOB_NO', this.filter.jobNo).formatObj2Json())
      }
      const requestBody = {
        menuType: this.menuType,
        conditions: this.buildConditions(simpleConditions),
        branchId: this.$store.getters.currentOfficeId,
        pageNum: this.filter.pageNum,
        pageSize: this.filter.pageSize
      }
      findDestinationBusinessJobs(requestBody).then(res => this.handleQueryData(res.data)).finally(() => {
        this.loading.close()
      })
    },
    // 构建查询条件（固定追加业务状态过滤，与销售查询保持一致）
    buildConditions(conditions) {
      const result = conditions ? [...conditions] : []
      // 是否尾程审核"无需审核"：value 为 'null' 时，转换为 IS NULL 查询
      for (const cond of result) {
        if (cond.fieldName === 'job.FINAL_STEP_AUDIT' && cond.value === 'null') {
          cond.operator = 'IS NULL'
          cond.value = ''
        }
      }
      if (!AdvancedSearchOption.hasField('job.JOB_STATE', result)) {
        result.push(new AdvancedSearchOption(null, 'job.JOB_STATE', [0, 1, 2, 3, 11, 13], 'IN').formatObj2Json())
      }
      return result
    },
    // 查询返回结果（完全参考销售查询：用局部变量results统计，最后赋值rowData）
    handleQueryData(res) {
      const results = Array.isArray(res.results.list) ? res.results.list : []
      this.filter.pageNum = res.results.pageNum
      this.filter.pageSize = res.results.pageSize
      this.total = Number(res.results.total)
      this.selectedRowCount = 0
      this.selectedJob = null
      // 统计票数和箱型箱量（与销售查询一致：用局部变量results）
      let b20Quantity = 0.0
      let b40Quantity = 0.0
      let b40hQuantity = 0.0
      let b45Quantity = 0.0
      let teuQuantity = 0.0
      for (const item of results) {
        const boxTypeStatisticsVo = item.boxTypeStatisticsVo
        if (boxTypeStatisticsVo) {
          b20Quantity += boxTypeStatisticsVo.b20 || 0
          b40Quantity += boxTypeStatisticsVo.b40 || 0
          b40hQuantity += boxTypeStatisticsVo.b40h || 0
          b45Quantity += boxTypeStatisticsVo.b45 || 0
          teuQuantity += boxTypeStatisticsVo.teu || 0
        }
      }
      const cartonQuantity = this.buildCartonQuantity(b20Quantity, b40Quantity, b40hQuantity, b45Quantity, teuQuantity)
      this.cartonQuantity = cartonQuantity
      this.initCartonQuantity = cartonQuantity
      this.ticketCount = results.length
      this.initTicketCount = results.length
      // 最后赋值rowData（与销售查询一致）
      this.rowData = results
      if (this.gridApi) {
        this.gridApi.clearFocusedCell()
      }
    },
    // 过滤财务字段的查询条件（尾程商务/海外跟单不需要这些字段）
    filterFinanceSearchItems(searchItems) {
      // 需要排除的财务字段的 fieldName / itemName 关键字
      const excludeFieldNames = [
        // 计提相关
        'provisioned', 'provisionedDate', 'salesProvision', 'csProvision', 'opProvision',
        'customsProvision', 'businessProvision', 'salesSupervisorProvision', 'opSupervisorProvision',
        // 利润/收入/支出/买价/卖价
        'realProfit', 'realIncome', 'realCost', 'buyPrice', 'sellPrice',
        // 超期利息/应收费用利息
        'overdueInterest', 'costInterest',
        // 各币种统计
        'usdReceivable', 'usdPayable', 'usdProfit',
        'vndReceivable', 'vndPayable', 'vndProfit',
        'rmbReceivable', 'rmbPayable', 'rmbProfit',
        // 财务审核
        'financialExamineDate', 'fcAuditDate',
        // 费用锁定
        'receivableChargeLockedStatus', 'payableChargeLockedStatus', 'payableChargeLockedPerson'
      ]
      const excludeKeywords = ['计提', '利息', '买价', '卖价', '利润', '收入', '支出', 'USD', 'VND', 'RMB']
      for (let i = searchItems.length - 1; i >= 0; i--) {
        const item = searchItems[i]
        const fieldName = (item.fieldName || item.itemName || '').toLowerCase()
        const displayName = item.itemName || item.displayName || ''
        let shouldExclude = false
        for (const name of excludeFieldNames) {
          if (fieldName === name.toLowerCase() || fieldName.indexOf(name.toLowerCase()) >= 0) {
            shouldExclude = true
            break
          }
        }
        if (!shouldExclude) {
          for (const kw of excludeKeywords) {
            if (displayName.indexOf(kw) >= 0) {
              shouldExclude = true
              break
            }
          }
        }
        if (shouldExclude) {
          searchItems.splice(i, 1)
        }
      }
    },
    // 拼接箱型箱量显示文本（与销售查询一致，使用 SeaExportConstants 箱型名称）
    buildCartonQuantity(b20, b40, b40h, b45, teu) {
      let result = ''
      if (b20 > 0) {
        result += b20 + '*' + SeaExportConstants.BOX_TYPE_20.chineseName + ','
      }
      if (b40 > 0) {
        result += b40 + '*' + SeaExportConstants.BOX_TYPE_40.chineseName + ','
      }
      if (b40h > 0) {
        result += b40h + '*' + SeaExportConstants.BOX_TYPE_40HQ.chineseName + ','
      }
      if (b45 > 0) {
        result += b45 + '*' + SeaExportConstants.BOX_TYPE_45.chineseName + ','
      }
      if (teu > 0) {
        result += teu + this.$t('SeaExport.TEU') + ','
      }
      if (result.length > 0) {
        result = result.substring(0, result.length - 1)
      }
      return result
    },
    // 行选中事件：勾选时统计选中行
    onRowSelected(event) {
      if (!this.gridApi) return
      const rows = this.gridApi.getSelectedRows()
      this.selectedRowCount = rows.length
      if (rows && rows.length > 0) {
        let b20 = 0
        let b40 = 0
        let b40h = 0
        let b45 = 0
        let teu = 0
        for (const item of rows) {
          const box = item.boxTypeStatisticsVo
          if (box) {
            b20 += box.b20 || 0
            b40 += box.b40 || 0
            b40h += box.b40h || 0
            b45 += box.b45 || 0
            teu += box.teu || 0
          }
        }
        this.ticketCount = rows.length
        this.cartonQuantity = this.buildCartonQuantity(b20, b40, b40h, b45, teu)
      } else {
        // 没有选中行时显示初始统计
        this.ticketCount = this.initTicketCount
        this.cartonQuantity = this.initCartonQuantity
      }
    },
    // 选中行
    onRowClicked(event) {
      this.selectedJob = event.data
    },
    readSelectedRows() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      return rows
    },
    // 校验只能选择一条数据（查看/编辑共用）
    getSingleSelectedRow() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_EndCommercePleaseSelectAtLeastOne'))
        return null
      }
      if (rows.length > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_EndCommerceOnlySelectOne'))
        return null
      }
      return rows[0]
    },
    // 查看
    toLook(row) {
      if (!row) {
        row = this.getSingleSelectedRow()
        if (!row) return
      }
      this.jumpBusinessModule(row, 'look')
    },
    // 编辑
    toEdit(row) {
      if (!row) {
        row = this.getSingleSelectedRow()
        if (!row) return
      }
      // 状态校验：仅"正操作"(jobState===0)且未被锁定(blocked)的记录才允许编辑，与详情页编辑按钮条件一致
      if (Number(row.jobState) !== 0 || JobUtils.isBlockJob(row)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_EndCommerceRecordNotAllowEdit'))
        return
      }
      this.jumpBusinessModule(row, 'edit')
    },
    // 获取行的尾程审核状态值：1=已审核, 0=未审核, null=无需审核
    // 后端返回有效枚举值时按返回值展示；空/null时返回null（无需审核）
    getFinalStepAuditStatusValue(row) {
      if (!row) return null
      const val = row.finalStepAudit
      if (val !== undefined && val !== null && val !== '') {
        const code = String(val)
        if (code === '1') return 1
        if (code === '0') return 0
      }
      return null
    },
    // 尾程审核状态展示文本：空值时显示"无需审核"
    getFinalStepAuditText(row) {
      const status = this.getFinalStepAuditStatusValue(row)
      if (status === 1) return this.$t('CargoMsg.Cargo_EndCommerceAudited')
      if (status === 0) return this.$t('CargoMsg.Cargo_EndCommerceNotAudited')
      return this.$t('CargoMsg.Cargo_EndCommerceNoAuditRequired')
    },
    // 审核通过
    toAuditPass() {
      const rows = this.gridApi.getSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_EndCommercePleaseSelectAtLeastOne'))
        return
      }
      // 校验选中数据是否包含已审核/无需审核的数据
      for (const row of rows) {
        const status = this.getFinalStepAuditStatusValue(row)
        if (status === 1) {
          this.$message.warning(this.$t('CargoMsg.Cargo_EndCommerceSelectedAudited'))
          return
        }
        if (status === null) {
          this.$message.warning(this.$t('CargoMsg.Cargo_EndCommerceSelectedNoAuditRequired'))
          return
        }
      }
      // 全部为未审核，调用审核通过接口（后端入参：body=jobKeys字符串数组，query=branchId）
      const jobKeys = rows.map(row => row.uuid).filter(Boolean)
      this.loading = getLoading()
      finalStepAuditPass(jobKeys, this.$store.getters.currentOfficeId).then((res) => {
        const data = (res && res.data) || {}
        const successJobNos = data.successJobNos || []
        // 仅将审核通过的数据置为已审核（海外跟单为空等未通过的数据保持原状态）
        rows.forEach(row => {
          if (successJobNos.includes(row.jobNo)) {
            row.finalStepAudit = '1'
          }
        })
        this.gridApi.refreshCells({
          columns: ['finalStepAudit'],
          force: true
        })
        // 海外跟单负责人为空，不能通过审核
        const noOverseasTrackingJobNos = data.noOverseasTrackingJobNos || []
        if (noOverseasTrackingJobNos.length > 0) {
          this.$message.warning(`当前业务编号:${noOverseasTrackingJobNos.join(',')}  海外跟单负责人为空，请检查。`)
        }
        if (successJobNos.length > 0) {
          this.$message.success(this.$t('CargoMsg.Cargo_EndCommerceAuditSuccessCount', { count: successJobNos.length }))
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 打开退回弹窗（校验选中订单是否为海运出口）
    toOpenReturnDialog() {
      const rows = this.gridApi.getSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.warning('请至少选择一条数据')
        return
      }
      // 校验是否全部为海运出口订单
      const nonSeJobs = rows.filter(row => row.lob !== 'SE')
      if (nonSeJobs.length > 0) {
        this.$message.warning('选择订单非流转订单，请选择海运出口订单操作')
        return
      }
      // 打开弹窗
      this.returnDialog.jobKeys = rows.map(row => row.uuid).filter(Boolean)
      this.returnDialog.reason = ''
      this.returnDialog.visible = true
    },
    // 确认退回
    toConfirmReturn() {
      if (!this.returnDialog.jobKeys || this.returnDialog.jobKeys.length === 0) {
        this.$message.warning('请至少选择一条数据')
        return
      }
      this.loading = getLoading()
      finalStepReturn(this.returnDialog.jobKeys, this.returnDialog.reason).then(() => {
        const count = this.returnDialog.jobKeys.length
        this.$message.success('退回成功' + count + '条')
        this.returnDialog.visible = false
        // 刷新列表
        this.toQuery()
      }).catch((err) => {
        this.$message.error(err && err.message ? err.message : '退回操作异常，请稍后重试')
      }).finally(() => {
        this.loading.close()
      })
    },
    // 根据业务类型跳转到对应的详情页面
    jumpBusinessModule(row, action) {
      const branchId = row.opOffice || row.salesOffice
      // 来源标识：从尾程商务/海外跟单列表页跳转，用于详情页返回
      const menuType = this.menuType
      // 跳转前将当前页数据存入 store，供详情页左侧列表展示
      this.$store.dispatch('destinationBusiness/setCurrentPageJobs', this.rowData)
      this.$store.dispatch('destinationBusiness/setSelectedJobNo', row.jobNo)
      this.$store.dispatch('destinationBusiness/setMenuType', menuType)
      // openNew=true 使页签标题显示业务编号（jobNo）
      const query = { key: row.jobNo, menuType, openNew: true }
      switch (row.lob) {
        case 'SE':
          this.$router.push({ name: 'DestinationBusinessSeDetail', query, params: { action, branchId }})
          break
        case 'SI':
          this.$router.push({ name: 'DestinationBusinessSiDetail', query, params: { action, branchId }})
          break
        case 'AE':
          this.$router.push({ name: 'DestinationBusinessAeDetail', query, params: { action, branchId }})
          break
        case 'AI':
          this.$router.push({ name: 'DestinationBusinessAiDetail', query, params: { action, branchId }})
          break
        case 'RE':
        case 'RI':
          this.$router.push({ name: 'DestinationBusinessReDetail', query, params: { action, branchId }})
          break
        case 'IE':
          this.$router.push({ name: 'DestinationBusinessIeDetail', query, params: { action, branchId }})
          break
      }
    },
    onGridReady(p) {
      this.gridApi = p.api
    }
  }
}
</script>

<style lang="scss" scoped>
// 统计行（票数/箱型箱量）：使用组件专属类名，不继承全局 .pagination-wrapper
// 的 flex-direction: row-reverse（那是文案跑到右侧的根源），也不与其他页面的
// .amount-sum 全局样式冲突（如销售查询页 keep-alive 缓存时的样式泄漏）
.destination-amount-sum {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 5px;
  padding-left: 20px;
}
</style>
